import IFrame10Field from "./IFrame10Field";
import IFrame11Field from "./IFrame11Field";
import IFrame12Field from "./IFrame12Field";
import IFrame1Field from "./IFrame1Field";
import IFrame2Field from "./IFrame2Field";
import IFrame3Field from "./IFrame3Field";
import IFrame4Field from "./IFrame4Field";
import IFrame5Field from "./IFrame5Field";
import IFrame6Field from "./IFrame6Field";
import IFrame7Field from "./IFrame7Field";
import IFrame8Field from "./IFrame8Field";
import IFrame9Field from "./IFrame9Field";

export const getIFrameById = (
    id,
    addImageHandler,
    selectedImages,
    changeImgStatus,
    changeImgSubtitle,
    setIframeList,
    index,
    iFrameData
) => {
    const iFrameListData = {
        1: (
            <IFrame1Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        2: (
            <IFrame2Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        3: (
            <IFrame3Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        4: (
            <IFrame4Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        5: (
            <IFrame5Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        6: (
            <IFrame6Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        7: (
            <IFrame7Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        8: (
            <IFrame8Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        9: (
            <IFrame9Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        10: (
            <IFrame10Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        11: (
            <IFrame11Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
        12: (
            <IFrame12Field
                addImageHandler={addImageHandler}
                selectedImages={selectedImages}
                changeImgStatus={changeImgStatus}
                changeImgSubtitle={changeImgSubtitle}
                setIframeList={setIframeList}
                index={index}
                iFrameData={iFrameData}
            />
        ),
    };
    return iFrameListData[id];
};
